import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as CryptoJS from 'crypto-js';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject } from 'rxjs';
const jwtHelper = new JwtHelperService();
// import { environment } from '../../../../environments/environment';

const environment = { envName: 'development' };

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  secretKey = 'bracWashProject2023#DevelopedBy@BMQA@2023_TonmoyrUdra';

  private menuSubject = new BehaviorSubject<any[]>(this.getMenu() || []);
  menu$ = this.menuSubject.asObservable();

  constructor(private cookieService: CookieService) {}

  private encrypt(value: string): string {
    if (environment.envName === 'development') {
      return value;
    } else {
      return CryptoJS.AES.encrypt(value, this.secretKey.trim()).toString();
    }
  }

  private decrypt(textToDecrypt: string) {
    if (environment.envName === 'development') {
      return textToDecrypt;
    } else {
      if (textToDecrypt === null) {
        return textToDecrypt;
      } else {
        return CryptoJS.AES.decrypt(
          textToDecrypt,
          this.secretKey.trim()
        ).toString(CryptoJS.enc.Utf8);
      }
    }
  }

  public encryptObjectUrl(obj: any): string {
    const jsonString = JSON.stringify(obj);

    const encrypted = CryptoJS.AES.encrypt(
      jsonString,
      this.secretKey.trim()
    ).toString();
    const base64String = encrypted.toString();
    return encodeURIComponent(base64String);
  }

  public decryptObjectUrl(encryptedString: string): any {
    try {
      const decodedString = decodeURIComponent(encryptedString);

      const decrypted = CryptoJS.AES.decrypt(
        decodedString,
        this.secretKey.trim()
      ).toString(CryptoJS.enc.Utf8);

      return JSON.parse(decrypted);
    } catch (error) {
      return null;
    }
  }

  public getToken() {
    return this.cookieService.get('shohay_token');
  }

  public setToken(token: string) {
    this.cookieService.set('shohay_token', token);
  }

  public deleteToken() {
    this.cookieService.delete('shohay_token');
  }

  public setResendOtpDisabledTimestamp() {
    const now = new Date().getTime();
    this.setLocalStorage('resendOtpDisabledTimestamp', now);
  }

  public getResendOtpDisabledTimestamp() {
    return this.getLocalStorage('resendOtpDisabledTimestamp');
  }

  public clearResendOtpDisabledTimestamp() {
    this.clearLocalStorageByKey('resendOtpDisabledTimestamp');
  }

  public setLocalStorage(key: string, data: any) {
    try {
      const encryptedData = this.encrypt(JSON.stringify(data));
      localStorage.setItem(key, encryptedData);
    } catch (error) {
      console.error(
        `Failed to set item in localStorage for key: ${key}`,
        error
      );
    }
  }

  public getLocalStorage(key: string) {
    try {
      const storedData = localStorage.getItem(key);
      if (storedData === null) {
        return '';
      }

      const decryptedData = this.decrypt(storedData);
      return JSON.parse(decryptedData);
    } catch (error) {
      console.error(
        `Failed to get and parse item from localStorage for key: ${key}`,
        error
      );
      return '';
    }
  }

  public clearLocalStorageByKey(key: string) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(
        `Failed to remove item from localStorage for key: ${key}`,
        error
      );
    }
  }

  static getSessionUserStatic(): any {
    const sessionUser = localStorage.getItem('sessionUser') as string;
    if (environment.envName === 'development') {
      return JSON.parse(sessionUser);
    } else {
      if (sessionUser === null) {
        return JSON.parse(sessionUser);
      } else {
        return CryptoJS.AES.decrypt(
          sessionUser,
          'bracWashProject2023#DevelopedBy@BMQA@2023_TonmoyrUdra'.trim()
        ).toString(CryptoJS.enc.Utf8);
      }
    }
  }

  public setSessionUserFromToken(token: string) {
    try {
      const tokenDecode = jwtHelper.decodeToken(token);
      delete tokenDecode.iat;
      delete tokenDecode.iss;
      localStorage.setItem('sessionUser', JSON.stringify(tokenDecode));
      return true;
    } catch (error) {
      return false;
    }
  }

  public setSessionUser(user: any) {
    localStorage.setItem('sessionUser', this.encrypt(JSON.stringify(user)));
  }

  public getSessionUser(): any {
    return JSON.parse(
      this.decrypt(localStorage.getItem('sessionUser') as string)
    );
  }

  public setMenu(menu: any[]) {
    localStorage.setItem('menu', this.encrypt(JSON.stringify(menu)));
    this.menuSubject.next(menu);
  }

  public getMenu(): any {
    return JSON.parse(this.decrypt(localStorage.getItem('menu') as string));
  }

  public clearSessionUser() {
    this.deleteToken();
    this.clearLocalStorageByKey('sessionUser');
    this.clearLocalStorageByKey('current_selected_ngo');
    this.clearLocalStorageByKey('current_selected_project');
    this.clearLocalStorageByKey('selected_menu');
    this.clearLocalStorageByKey('selected_sub_menu');
    this.clearLocalStorageByKey('signedUpEmail');
    this.clearLocalStorageByKey('menu');
    this.clearLocalStorageByKey('current_selected_role');
  }

  public getSessionUserRole() {
    return this.getSelectedRole();
    //  return this.getSessionUser().role;
  }

  public setNgoInLocalStorage(ngo: any) {
    localStorage.setItem(
      'current_selected_ngo',
      this.encrypt(JSON.stringify(ngo))
    );
  }

  public getNgoInLocalStorage() {
    return JSON.parse(
      this.decrypt(
        localStorage.getItem('current_selected_ngo') as string
      ) as string
    );
  }

  static getCurrentSelectedNgoStatic(): any {
    const selectedNgo = localStorage.getItem('current_selected_ngo') as string;
    if (environment.envName === 'development') {
      return JSON.parse(selectedNgo);
    } else {
      if (selectedNgo === null) {
        return JSON.parse(selectedNgo);
      } else {
        return CryptoJS.AES.decrypt(
          selectedNgo,
          'bracWashProject2023#DevelopedBy@BMQA@2023_TonmoyrUdra'.trim()
        ).toString(CryptoJS.enc.Utf8);
      }
    }
  }

  public setSelectedRole(role: any) {
    console.log(role);
    localStorage.setItem(
      'current_selected_role',
      this.encrypt(JSON.stringify(role))
    );
  }

  public getSelectedRole() {
    return JSON.parse(
      this.decrypt(
        localStorage.getItem('current_selected_role') as string
      ) as string
    );
  }

  public setProjectInLocalStorage(program: any) {
    localStorage.setItem(
      'current_selected_project',
      this.encrypt(JSON.stringify(program))
    );
  }

  public getProjectFromLocalStorage() {
    return JSON.parse(
      this.decrypt(
        localStorage.getItem('current_selected_project') as string
      ) as string
    );
  }

  public deleteProjectFromLocalStorage() {
    this.clearLocalStorageByKey('current_selected_project');
  }

  public getIsNgoAdmin(): boolean {
    const role = this.getSessionUserRole();
    return (
      this.getSessionUserRole().short_form === 'admin' ||
      this.getSessionUserRole().short_form === 'donor'
    );
  }

  public getIsDonorAdmin(): boolean {
    const role = this.getSessionUserRole();
    return this.getSessionUserRole().short_form === 'donor';
  }

  public getIsShohayOpsAdmin(): boolean {
    const role = this.getSessionUserRole();
    return this.getSessionUserRole().short_form === 'shohay_ops';
  }

  public getIsCorporateAdmin(): boolean {
    const role = this.getSessionUserRole();
    return this.getSessionUserRole().short_form === 'corporate_admin';
  }

  public getIsCorporateEmployee(): boolean {
    const role = this.getSessionUserRole();
    return this.getSessionUserRole().short_form === 'corporate_employee';
  }

  public getIsCustomEmployee(): boolean {
    const role = this.getSessionUserRole();
    return this.getSessionUserRole().short_form.startsWith('custom');
  }

  public getIsSuperAdmin(): boolean {
    const role = this.getSessionUserRole();
    return this.getSessionUserRole().short_form === 'system_admin';
  }

  public getIsCampaignManager(): boolean {
    const role = this.getSessionUserRole();
    return this.getSessionUserRole().short_form === 'campaign_manager';
  }

  public getIsStoreManager(): boolean {
    const role = this.getSessionUserRole();
    return this.getSessionUserRole().short_form === 'store_manager';
  }

  public getIsCorporateRole(): boolean {
    return (
      this.getSessionUserRole().short_form === 'corporate_admin' ||
      this.getSessionUserRole().short_form === 'campaign_manager' ||
      this.getSessionUserRole().short_form === 'store_manager' ||
      this.getSessionUserRole().short_form.startsWith('custom')
    );
  }

  // public getIsOpsAdmin(): boolean {
  //   const role = this.getSessionUserRole();
  //   return this.getSessionUserRole().short_form === 'shohay_ops';
  // }

  public setSelectedMenuInfo(data: any) {
    localStorage.setItem('selected_menu', this.encrypt(JSON.stringify(data)));
  }

  public getSelectedMenuInfo() {
    return JSON.parse(
      this.decrypt(localStorage.getItem('selected_menu') as string)
    );
  }

  public setSelectedSubMenuInfo(data: any) {
    localStorage.setItem(
      'selected_sub_menu',
      this.encrypt(JSON.stringify(data))
    );
  }

  public getSelectedSubMenuInfo() {
    return JSON.parse(
      this.decrypt(localStorage.getItem('selected_sub_menu') as string)
    );
  }

  public setSignedUpEmail(email: string) {
    this.setLocalStorage('signedUpEmail', email);
  }

  public getSignedUpEmail() {
    return this.getLocalStorage('signedUpEmail');
  }

  public clearSignedUpEmail() {
    this.clearLocalStorageByKey('signedUpEmail');
  }

  public getIsNotificationRegistered() {
    const isNotificationRegistered = this.getLocalStorage(
      'isNotificationRegistered'
    );
    return isNotificationRegistered === 'yes' ? true : false;
  }

  public setIsNotificationRegistered(isNotificationRegistered: 'yes' | 'no') {
    this.setLocalStorage('isNotificationRegistered', isNotificationRegistered);
  }
}
